import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "open-in-new",
  "use": "open-in-new-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"open-in-new\"><path fill-rule=\"evenodd\" d=\"M5 19V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7H5Zm9-14h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol